export default __webpack_public_path__ + "static/1-a61d0b7afc0dd767b183440ea5867581.jpg";